import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import PatientForm from './PatientForm';
import PatientSelectorPanel from './PatientSelectorPanel';
import {useTranslation} from "react-i18next";
import { logEvent } from '../../analytics';

export default function PatientLinkModal({ open, onClose, onPatientSelected }) {
  const { t } = useTranslation();

  const [selectedPatient, setSelectedPatient] = useState(null);
  const [editingPatient, setEditingPatient] = useState(null);
  const [isFormVisible, setIsFormVisible] = useState(false);

  return (
    <>
      <Modal
        forceRender
        open={open}
        onCancel={onClose}
        onOk={() => {
          if (selectedPatient) {
            logEvent('SessionDetails', 'LinkPatient');
            onPatientSelected(selectedPatient);
          }
        }}
        okText="Select"
        title={t('patient_modal.title')}
        okButtonProps={{ disabled: !selectedPatient }}
        footer={(
          <div style={{ display: 'flex', justifyContent: 'center', gap: 12, marginTop: 30 }}>
            <Button onClick={onClose}>
              {t('common.cancel')}
            </Button>
            <Button
              type="primary"
              onClick={() => selectedPatient && onPatientSelected(selectedPatient)}
              disabled={!selectedPatient}
            >
              {t('common.confirm')}
            </Button>
          </div>
        )}
      >
        <div style={{ marginTop: 20}}>
          <PatientSelectorPanel
            selectedPatient={selectedPatient}
            fromLinkPatientModal={true}
            onSelect={setSelectedPatient}
            onAddPatient={() => {
              setEditingPatient(null);
              setIsFormVisible(true);
            }}
            onEditPatient={() => {
              setEditingPatient(selectedPatient);
              setIsFormVisible(true);
            }}
            onUnlinkPatient={() => setSelectedPatient(null)}
          />
        </div>
      </Modal>

      <PatientForm
        isOpen={isFormVisible}
        editingPatient={editingPatient}
        onCancel={() => {
          setEditingPatient(null);
          setIsFormVisible(false);
        }}
        onSave={(savedPatient) => {
          setSelectedPatient(savedPatient);
          setEditingPatient(null);
          setIsFormVisible(false);
        }}
      />
    </>
  );
}